import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { connect } from "react-redux";
import {} from "../../../../Redux/Actions/actions";
import { randomColors } from "../../../../Utils/colorpallet";
import { Stack, Typography, Badge, Box, Avatar, Grid } from "@mui/material";
import moment from "moment";

const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    searchterm: data.searchterm,
    agentList: data.agentList,
    internalChatData: contactListData.internalChatData,
  };
};

const InternalAgentList = (props) => {
  const { internalChat, index, val } = props;
  const agentId = JSON.parse(localStorage.getItem("tokenAgent"));

  const formatTime = (lastmessagetime) => {
    if (lastmessagetime) {
      const messageTime = moment(lastmessagetime, "hh:mm:A");
      const currentTime = moment();
      const diffMinutes = currentTime.diff(messageTime, "minutes");

      if (diffMinutes < 1) {
        return "just now";
      } else if (diffMinutes < 60) {
        return `${diffMinutes} m`;
      } else if (diffMinutes < 120) {
        const diffHours = Math.floor(diffMinutes / 60);
        const remainingMinutes = diffMinutes % 60;
        return `${diffHours}hr ${remainingMinutes}m`;
      } else if (diffMinutes < 1440) {
        const diffHours = Math.floor(diffMinutes / 60);
        return `${diffHours} ${diffHours === 1 ? "hr" : "hrs"} ago`;
      } else if (diffMinutes < 2880) {
        return "yst";
      } else {
        const diffDays = Math.floor(diffMinutes / 1440);
        return `${diffDays} ${diffDays === 1 ? "day" : "days"} ago`;
      }
    }
  };

  return (
    <div
      key={val.id}
      className={
        props.internalChatData
          ? props.internalChatData.chat_session_id === val.chat_session_id
            ? "d-flex chat-active "
            : "chat-contact d-flex"
          : "chat-contact d-flex"
      }
      onClick={() => {
        internalChat(val, index);
      }}
      style={{
        cursor: "pointer",
        width: "100%",
        userSelect: "none",
        padding: "5px 5px",
        marginBottom: "2px",
      }}
    >
      <Stack
        direction={"row"}
        alignItems={"center"}
        spacing={0.5}
        sx={{ width: "100%", height: "100%" }}
      >
        <Box className="position-relative">
          {/* user profile  */}
          {props.loader ? (
            <Skeleton
              animation="wave"
              variant="circular"
              width={35}
              height={35}
            />
          ) : (
            <Avatar
              className="box-inset2 position-relative"
              sx={{
                background: randomColors[index],
                height: "35px",
                width: "35px",
                fontSize: "12px",
                fontWeight: 600,
                border: "2px solid white",
              }}
            >
              {val.reciverDetails
                ? val.reciverDetails[0]._id !== agentId.id
                  ? val.reciverDetails[0].username.slice(0, 2).toUpperCase()
                  : val.senderDetails[0].username.slice(0, 2).toUpperCase()
                : val.username.slice(0, 2).toUpperCase()}
            </Avatar>
          )}
          {/* couter */}
          <Stack className="status-position2">
            <Badge
              max={10}
              badgeContent={val.unreadcount}
              color="#FFFF"
              sx={{
                "& .MuiBadge-badge": {
                  background: "#db3240",
                  fontWeight: 700,
                  fontSize: "7px",
                  color: "white",
                  padding: "0 3px",
                  height: "18px",
                },
              }}
            />
          </Stack>
          {/* status  */}
          {props.loader ? (
            <></>
          ) : (
            <span
              className={`${
                val.reciverDetails
                  ? val.reciverDetails[0]._id != agentId.id
                    ? val.reciverDetails[0].agent_status === "Available"
                      ? "online status-position"
                      : val.reciverDetails[0].agent_status === "Not Available"
                        ? "discont status-position"
                        : "busy status-position"
                    : val.senderDetails[0].agent_status === "Available"
                      ? "online status-position"
                      : val.senderDetails[0].agent_status === "Not Available"
                        ? "discont status-position"
                        : "busy status-position"
                  : val.agent_status === "Available"
                    ? "online status-position"
                    : val.agent_status === "Not Available"
                      ? "discont status-position"
                      : "busy status-position"
              }`}
            ></span>
          )}
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "100%",
          }}
        >
          <Stack
            direction={"row"}
            justifyContent={"start"}
            alignItems={"center"}
          >
            <Stack
              direction={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              className="w-100"
            >
              {props.loader ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={100}
                  height={10}
                />
              ) : (
                <Grid item xs zeroMinWidth sx={{ width: "10em" }}>
                  <Typography
                    noWrap
                    sx={{
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: props.internalChatData
                        ? props.internalChatData.chat_session_id ===
                          val.chat_session_id
                          ? "white"
                          : "#0b3363"
                        : "#0b3363",
                    }}
                  >
                    {val.reciverDetails
                      ? val.reciverDetails[0]._id !== agentId.id
                        ? val.reciverDetails[0].username
                        : val.senderDetails[0].username
                      : val.username}
                  </Typography>
                </Grid>
              )}
            </Stack>
          </Stack>

          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Stack className="col-8">
              {props.loader ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={60}
                  height={10}
                  sx={{ marginTop: "10px" }}
                />
              ) : (
                <Typography
                  variant="caption"
                  noWrap
                  sx={{
                    fontSize: "12px",
                    color: props.internalChatData
                      ? props.internalChatData.chat_session_id ===
                        val.chat_session_id
                        ? "white"
                        : "#868585"
                      : "",
                    maxWidth: "8rem",
                  }}
                >
                  {val.lastmessage}
                </Typography>
              )}
            </Stack>
            <Stack
              className="col-4"
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={0.5}
            >
              {props.loader ? (
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  width={30}
                  height={10}
                />
              ) : (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "10px",
                    color: props.internalChatData
                      ? props.internalChatData.chat_session_id ===
                        val.chat_session_id
                        ? "white"
                        : "#868585"
                      : "",
                  }}
                >
                  {formatTime(val.lastmessagetime)}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </div>
  );
};

export default connect(mapStateToProps, {})(InternalAgentList);
